<template>
  <div class="chanceLeftContainer" :style="styleObj">
    <i18n path="lottery_chance_note" tag="span">
      <span class="chanceHighlight">{{ lotteryTicketCount }}</span>
    </i18n>
  </div>
</template>

<script>
import { px2vw } from '@/components/templates/helper';
import { mapState } from 'vuex';

export default {
  props: {
    backgroundImage: {
      type: String,
      require: true
    },
    fontColor: {
      type: String,
      require: true
    },
    verticalDirection: {
      type: String,
      require: true
    },
    verticalDistance: {
      type: Number,
      require: true
    },
    moduleName: {
      type: String,
      require: true
    }
  },
  computed: {
    ...mapState('app', {
      lotteryTicketCount: function(state) {
        return (
          state[this.moduleName] &&
          state[this.moduleName].actData &&
          state[this.moduleName].actData.remainTimes
        );
      }
    }),
    styleObj() {
      const style = {
        color: this.fontColor,
        background: `center / cover url("${this.backgroundImage}") no-repeat`
      };
      const verticalDirection = this.verticalDirection;
      style[verticalDirection] = px2vw(this.verticalDistance);
      return style;
    }
  }
};
</script>

<style lang="less" scoped>
.chanceLeftContainer {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 560px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 28px;

  .chanceHighlight {
    color: #ff0b0b;
  }
}
</style>
